import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 203px;
  background: #FFD836;
  background-image: url('../assets/headerbg.png')
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  color: #000000;
`;
